import * as React from "react";

import { useSelector } from "react-redux";
import { RootState } from "../";

import { useAnalyticsUtil } from "@skv/core";
import { useThunkDispatch } from "../";

import { actions, FAVOURITES_ENUM } from "./";

export const useFavourites = () => {
  const dispatch = useThunkDispatch();
  const { trackPageLink } = useAnalyticsUtil();

  const favourites = useSelector((state: RootState) => state.favourites);

  const handleFavourite = React.useCallback(
    (id: number, type: FAVOURITES_ENUM) => {
      dispatch(actions.addFavourite(id, type));

      trackPageLink(
        type === FAVOURITES_ENUM.OPPORTUNITY
          ? "favourite-opportunity"
          : "favourite-organisation"
      );
    },
    [dispatch, trackPageLink]
  );

  const handleUnfavourite = React.useCallback(
    (id: number, type: FAVOURITES_ENUM) => {
      dispatch(actions.removeFavourite(id, type));
      trackPageLink(
        type === FAVOURITES_ENUM.OPPORTUNITY
          ? "remove-favourite-opportunity"
          : "remove-favourite-organisation"
      );
    },
    [dispatch, trackPageLink]
  );

  return { favourites, handleFavourite, handleUnfavourite };
};
